import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=52d8773e&scoped=true&"
import script from "./BaseChip.vue?vue&type=script&lang=ts&"
export * from "./BaseChip.vue?vue&type=script&lang=ts&"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=52d8773e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d8773e",
  null
  
)

export default component.exports